import { ApolloProvider } from '@apollo/client';
import { SearchkitClient, SearchkitProvider } from '@searchkit/client';
import React, { Dispatch, SetStateAction, useCallback } from 'react';
import { Organization } from 'sr-types/lib/organization/v1/graphql';
import { ENTITY_CONSTANTS } from '../common/constants/entityConstants';
import { FEATURE_CONSTANTS } from '../common/constants/featureConstants';
import ListView from '../common/list/ListView';
import { searchClient, slimResultsQuery } from '../common/list/slimQuery';
import useOrganizationPreFilters from '../organization/useOrganizationPreFilters';
import KeyOrganizationList from './KeyOrganizationList';
import { ProductionOrganizationInfoWithKey } from './helpers/organizationUtils';

type KeyOrganizationListViewProps = {
    productionId: string;
    query: string;
    organizationState: Organization;
    orgWithKey: ProductionOrganizationInfoWithKey[];
    setIsCreate: Dispatch<SetStateAction<boolean>>;
    setOrganizationState: Dispatch<SetStateAction<Organization>>;
    setSearchAllOrganization: Dispatch<SetStateAction<boolean>>;
    setQuery: Dispatch<SetStateAction<string>>;
};

export default ({
    query,
    setIsCreate,
    setOrganizationState,
    organizationState,
    setSearchAllOrganization,
    setQuery,
    productionId,
    orgWithKey
}: KeyOrganizationListViewProps) => {
    const searchkit = new SearchkitClient();
    const preFilters = useOrganizationPreFilters();

    const renderKeyOrganizationList = useCallback(
        (props) => (
            <KeyOrganizationList
                {...props}
                orgWithKey={orgWithKey}
                productionId={productionId}
                setSearchAllOrganization={setSearchAllOrganization}
                setIsCreate={setIsCreate}
                setQuery={setQuery}
            />
        ),
        [orgWithKey, productionId, setSearchAllOrganization, setIsCreate, setQuery]
    );

    return (
        <ApolloProvider client={searchClient}>
            <SearchkitProvider client={searchkit}>
                <ListView
                    id="account_organization"
                    entity={ENTITY_CONSTANTS.organization}
                    feature={FEATURE_CONSTANTS.organizationResource}
                    uri={undefined}
                    query={slimResultsQuery(ENTITY_CONSTANTS.organization)}
                    EntityListRenderer={renderKeyOrganizationList}
                    showBreadCrumbs={false}
                    containerSx={{ height: '100%', m: 0, p: 1 }}
                    facetsVisibility={{
                        filters: false,
                        searchPanel: true,
                        promotedFacets: false,
                        quickFilter: false
                    }}
                    initialSearchQuery={query}
                    preFilters={preFilters}
                />
            </SearchkitProvider>
        </ApolloProvider>
    );
};
